module.exports = __webpack_public_path__ + "img/room-2.9f70bedd.jpg";